<template>
  <div 
    ref="header"
    class="ai-generate-header d-flex align-items-center justify-content-between border-bottom border-gray-lighten p-gd-2 w-100 cursor-move"
    @mousedown="handleDragStart"
  >
    <span class="ai-generate-title fs-db-28 fw-500 text-makeweb-ai-gradient-2">
      {{ $t('engine.aiGenerate.lblTitle', languageEngine) }}
    </span>
    <div class="ai-generate-close cursor-pointer border-radius bg-hover-gray-lighten" @click.stop="handleClose">
      <i class="fal fa-times fs-sa-16"></i>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'AIGenerateHeader',
  computed: {
    ...mapGetters({
      languageEngine: 'designIframe/userPreference/languageEngine'
    })
  },
  methods: {
    handleClose() {
      this.$emit('close');
    },
    handleDragStart(e) {
      // Don't start drag if clicking on close button
      if (e.target.closest('.ai-generate-close')) {
        return;
      }
      this.$emit('drag-start', e);
    }
  }
};
</script>

<style lang="scss" scoped>
.ai-generate-header {
  .ai-generate-title {
    height: 24px;
  }
  .ai-generate-close {
    width: 20px;
    height: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: background-color 0.2s;
    i {
      color: #515A63;
    }
  }
}
</style>
